/**
 * 认证模块：登录 / 注册 / 登出 / 我的信息
 * ★ 2026-08-24 清理：移除 smsLogin / sendSms / getCaptcha —
 *   后端无 /auth/sms-login、/auth/send-sms、/auth/captcha 路由，
 *   保留这些函数只会产生假报错（T4 后门清理闭环）。后端实现后按需恢复。
 */
import { get, post } from './http';
import type { LoginResult, RegisterParams, User } from '@/types';

export interface LoginParams {
  username: string;
  password: string;
  captcha_id?: string;
  captcha_code?: string;
}

/** 密码登录 */
export function login(params: LoginParams): Promise<LoginResult> {
  return post<LoginResult>('/auth/login', params);
}

/** 注册 */
export function register(params: RegisterParams): Promise<{ user_id: number }> {
  return post<{ user_id: number }>('/auth/register', params);
}

/** 登出 */
export function logout(): Promise<null> {
  return post<null>('/auth/logout');
}

/** 获取当前用户信息 */
export function getMe(): Promise<User> {
  return get<User>('/users/me');
}
